var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 2C3.49238 2 2 3.49238 2 5.33333V6.28571H2.95238V5.33333C2.95238 4.01837 4.01837 2.95238 5.33333 2.95238H18.6667C19.9816 2.95238 21.0476 4.01837 21.0476 5.33333V18.6667C21.0476 19.9816 19.9816 21.0476 18.6667 21.0476H5.33333C4.01837 21.0476 2.95238 19.9816 2.95238 18.6667H2C2 20.5076 3.49238 22 5.33333 22H18.6667C20.5076 22 22 20.5076 22 18.6667V5.33333C22 3.49238 20.5076 2 18.6667 2H5.33333ZM12.5673 6.8459L15.8239 11.3238H2.47619L2.47619 12.2762L15.8296 12.2762L12.5673 16.7619L13.3375 17.3221L17.3507 11.8039L13.3375 6.28574L12.5673 6.8459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.24fe0b960ff03cf21910e564d65f7db5.svg";
export { ForwardRef as ReactComponent };